var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsWindatlasColored(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#c51b8a;}.cls-1{opacity:0.2;}.cls-3,.cls-4{fill:none;stroke:#202349;stroke-miterlimit:10;}.cls-3{stroke-linecap:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_4",
    "data-name": "Calque 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.05,
    width: 19.7,
    height: 19.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.76,
    width: 19.7,
    height: 19.7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "afd93aa1-f475-4971-aea1-7d42c7265645"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 16.48,
    y: 19.77,
    width: 9.17,
    height: 2.93,
    rx: 0.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 21.07,
    cy: 12.94,
    r: 1.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 20.09,
    y1: 14.68,
    x2: 20.09,
    y2: 17.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 22.07,
    y1: 14.68,
    x2: 22.07,
    y2: 17.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.19,32.15v5a1.09,1.09,0,0,1-1.09,1.09h0A1.09,1.09,0,0,1,20,37.13V22.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.19,22.91v6.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20,22.91,14.53,37.36a1.09,1.09,0,0,1-1.4.63h0a1.09,1.09,0,0,1-.64-1.4l5.22-13.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.26,22.9l5.49,14.44a1.08,1.08,0,0,0,1.4.63h0a1.08,1.08,0,0,0,.63-1.4L24.57,22.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.08,13.66l-1.58.59a1,1,0,0,1-1.31-.61L15,10.41a1,1,0,0,1,.6-1.31l14-5.17"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 25.76,
    y1: 11.2,
    x2: 23.05,
    y2: 12.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.51,9.08l-3.07,1.13"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 30.75,
    y: 1.85,
    width: 2.62,
    height: 8.19,
    rx: 0.45,
    transform: "translate(-0.08 11.47) rotate(-20.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14.78,10.43,8.87,12.61a.86.86,0,0,0-.51,1.1L9,15.44a.87.87,0,0,0,1.1.51L16,13.77"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 5.47,
    y: 13.18,
    width: 1.93,
    height: 4.46,
    rx: 0.18,
    transform: "translate(-4.93 3.18) rotate(-20.25)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 8.36,
    y1: 13.71,
    x2: 7.15,
    y2: 14.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 9,
    y1: 15.44,
    x2: 7.74,
    y2: 15.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.08,2.34a4.09,4.09,0,0,1,2.37,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M18.47,19.87V19a1.38,1.38,0,0,1,1.38-1.38h2.49A1.37,1.37,0,0,1,23.71,19v.87"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsWindatlasColored);
export default __webpack_public_path__ + "static/media/icons_windatlas_colored.2cc8f744861270677a376b28a25ccf0d.svg";
export { ForwardRef as ReactComponent };